import * as React from 'react';
import { RootState } from '../store';

import { Dispatch, Action } from 'redux';
import { returntypeof } from '../helper';
import { connect } from 'react-redux';
import { TOGGLE_CHECKOUT, TOGGLE_DOWNLOAD, LOGOUT } from '../store/login';
import { LOAD_COMMS_PHOTOS, Photo } from '../store/photos';
import { Node, SELECT_PROFILE, COLLAPSE_MENU } from '../store/profile';

const mapStateToProps = (state: RootState) => ({
    login: state.login,
    profiles: state.profile.profiles,
    selected: state.profile.selected,
    lookup: state.info.lookup,
    ticket: state.login.ticket,
    payment_gateway: state.login.payment_gateway,
    loaded: state.profile.loaded,
    num_photos: state.photo.selected.size,
    fields: state.login.profile_fields,
    selected_dl: state.photo.selected,
    webshop: state.webshop,
    collapsed: state.profile.collapsed,
    bricks: state.photo.bricks,
    photo: state.photo,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    toggleProfile: (selected?: number) => {
        dispatch({ type: SELECT_PROFILE, selected })
    },
    toggleFilter: (selected?: number) => {
        dispatch({ type: SELECT_PROFILE, selected })
    },
    toggleCommunity: (selected?: number) => {
        dispatch({ type: LOAD_COMMS_PHOTOS, selected })
    },
    toggleCollapse: () => {
        dispatch({ type: COLLAPSE_MENU })
    },
    toggleCheckout: () => {
        dispatch({ type: TOGGLE_CHECKOUT })
    },
    toggleDownload: () => {
        dispatch({ type: TOGGLE_DOWNLOAD })
    },
    logout: () => {
        dispatch({ type: LOGOUT })
    }
});

const stateProps = returntypeof(mapStateToProps);
const dispatchProps = returntypeof(mapDispatchToProps);

type Props = typeof stateProps & typeof dispatchProps;

type State = {
    showFilter: boolean
    community: boolean
}

export interface Filters {
    type: string,
    value: string
}

export interface Events {
    title: string
}

class Filter extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            showFilter: false,
            community: false,
        }

    }


    toggleFilter = () => (e: React.MouseEvent) => {
        if (!this.state.showFilter) {
            document.addEventListener('click', this.handleOusideClick, false);
        }
        else {
            document.removeEventListener('click', this.handleOusideClick, false);
        }
        this.setState({ showFilter: !this.state.showFilter })
    }

    handleOusideClick = (e: any) => {
        let node = document.getElementById("filterStart");


        if (node != undefined) {
            if (node.contains(e.target)) {
                return
            }
            else {
                if (!this.state.showFilter) {
                    document.addEventListener('click', this.handleOusideClick, false);
                }
                else {
                    document.removeEventListener('click', this.handleOusideClick, false);
                }
                this.setState({ showFilter: !this.state.showFilter })
            }
        }

    }

    onKeyPress = (e: React.KeyboardEvent<any>) => {
        switch (e.key) {
            case "Esc":
            case "Escape":
                this.setState({ showFilter: false });
                break;
        }
    }

    toggleProfile = (to_select: number | undefined) => (e: React.MouseEvent<any>) => {
        this.props.toggleProfile(to_select);
        this.setState({ community: false })
    }

    renderNode = (node: Node, count: number, to_select: number | undefined) => {

        let resp: React.ReactElement[] = [];

        let offset = 95;

        let num = this.props.profiles.length;

        let profiles = [];

        let left_offset = ((num - 1) * offset) / 1.90;

        let cur_selected = this.props.selected;

        if (cur_selected != undefined && count == cur_selected) {
            to_select = undefined;
        }

        let name = node["sb_profileName"].toString();

        if (name.length > 15) {
            name = name.substring(0, 15);
            name += "..";
        }

        if (node["sb_profileName"] != undefined) {
            resp.push(<span>{name}</span>);
        }

        return resp;

    }

    renderProfile() {

        if (!this.props.loaded) {
            return (
                <div className="profile">
                    <div className="empty-icon">
                        <i className="icon icon-3x icon-people"></i>
                    </div>
                    <div className="loading loading-lg"></div>
                </div>
            )

        }
        if (this.props.profiles.length > 0 && this.props.ticket != undefined) {

            let ticket = encodeURIComponent(this.props.ticket);


            let num = this.props.profiles.length;

            let profiles = [];

            let cur_selected = this.props.selected;

            for (let i = num - 1; i >= 0; i--) {
                let next_profile = this.props.profiles[i];

                let to_select: number | undefined = i;

                if (cur_selected != undefined && i == cur_selected) {
                    to_select = undefined;
                    profiles.push(
                        <li className="active" key={"p" + i}><a style={{ cursor: "pointer" }} onClick={this.toggleProfile(to_select)}><img key={"profile" + i} src={`/api/v1/preview/betterthumb/${next_profile.id}?sbpportal-ticket=${ticket}`} width="30px" height="30px"></img>{this.renderNode(next_profile, i, to_select)}</a></li>
                    );
                }
                else {
                    profiles.push(
                        <li key={"p" + i}><a style={{ cursor: "pointer" }} onClick={this.toggleProfile(to_select)}><img key={"profile" + i} src={`/api/v1/preview/betterthumb/${next_profile.id}?sbpportal-ticket=${ticket}`} width="30px" height="30px"></img>{this.renderNode(next_profile, i, to_select)}</a></li>
                    );
                }

            }
            return (
                <div className="profile">
                    <figure className="profile-stack" >
                        {profiles}
                    </figure>
                </div>
            )
        }

        if (this.props.profiles.length == 0 && this.props.loaded) {
            return (
                <div className="profile">
                    <i className="far fa-user" style={{ fontSize: "50px", marginBottom: '5%' }}></i>
                    <p className="empty-title h5">No Students Found</p>
                    <p className="empty-subtitle">We couldn't find any students associated to your login.  If you think this is in error, please contact your school.</p>
                </div>
            )
        }

    }

    // Method for sorting and creating the year filter list
    renderYearFilter() {
        let photos = this.props.bricks.filter(brick => brick.type == "photo") as Photo[];
        
        if(this.state.community){
            photos = this.props.photo.communitybricks.filter(brick => brick.type == "photo") as Photo[];
        }

        let filter = [] as Filters[];
        photos.forEach(photo => {
            if (photo.sb_year != undefined) {
                let yearFilter = { type: "year", value: photo.sb_year } as Filters
                const exists = filter.some(v => (v.value === yearFilter.value));
                if (!exists) {
                    filter.push(yearFilter);
                }
            }
        })


        let yearFilterList = filter.filter(v => v.type == "year");
        let year = []

        for (let i = 0; i < yearFilterList.length; i++) {
            let y = yearFilterList[i];
            // Checks to see if it should be active or not
            let exists = this.props.photo.filters.some(v => (v.value === y.value));
            if (exists) {
                year.push(<li key={"y" + i} className="active"><a onClick={this.addFilter(y)}>{y.value}</a></li>)
            } else {
                year.push(<li key={"y" + i}><a onClick={this.addFilter(y)}>{y.value}</a></li>);
            }
        }

        return year;

    }

    // Method for generating the Event filter list
    renderEventFilter() {
        let photos = this.props.bricks.filter(brick => brick.type == "photo") as Photo[];

        if(this.state.community){
            photos = this.props.photo.communitybricks.filter(brick => brick.type == "photo") as Photo[];
        }

        let filter = [] as Filters[];
        photos.forEach(photo => {
            if (photo.sb_event != undefined) {

                let filters = { type: "event", value: photo.sb_event } as Filters
                const exists = filter.some(v => (v.value === filters.value));
                if (!exists) {
                    filter.push(filters);
                }
            }
        })


        let filterList = filter.filter(v => v.type == "event");
        let display = []

        let sort = filterList.sort((a, b) => a.value.localeCompare(b.value)).map((item) => item);

        for (let i = 0; i < sort.length; i++) {
            let y = sort[i];
            let value = y.value.toString();
            if (value.length > 40) {
                value = value.substring(0, 40);
                value += "..";
            }
            // Checks to see if it should be active or not
            let exists = this.props.photo.filters.some(v => (v.value === y.value));
            if (exists) {
                display.push(<li key={"e" + i} className="active"><a onClick={this.addFilter(y)}>{value}</a></li>)
            } else {
                display.push(<li key={"e" + i}><a onClick={this.addFilter(y)}>{value}</a></li>);
            }
        }

        return display;

    }

    addFilter = (filter: Filters) => (e: React.MouseEvent<any>) => {
        let cur_selected = this.props.selected;
        const exists = this.props.photo.filters.some(v => (v.value === filter.value));
        if (!exists) {
            this.props.photo.filters.push(filter);
        } else {
            var index = this.props.photo.filters.indexOf(filter);
            this.props.photo.filters.splice(index, 1);
        }

        if (this.state.community && this.props.login.enable_community.toUpperCase() != "FALSE" ) {
            this.props.toggleCommunity()
        } else {
            this.props.toggleFilter(cur_selected);
        }
    }

    clearFilter = () => {
        this.props.photo.filters = [];
        this.props.toggleFilter();
        this.setState({ community: false })
    }

    toggleCommunity = () => (e: React.MouseEvent<any>) => {
        let cur_selected = this.props.selected;
        if (this.state.community) {
            this.props.toggleFilter();
            this.setState({ community: false })
        }
        else {
            this.props.toggleCommunity(cur_selected);
            this.setState({ community: true });
        }

    }

    public render() {

        let clearFilter;
        if (this.props.photo.filters.length > 0 || this.props.selected != undefined || this.state.community == true) {
            clearFilter = <div id="filter-reset" className="pull-left active">
                <button className="filters-reset" onClick={this.clearFilter}>
                    <img src="/assets/icons/close.svg" width="20px" height="auto"></img>
                                    Clear Search
                                </button>
            </div>
        }

        let showFilter = true;
        if(this.props.login.enable_community.toUpperCase() == "FALSE" && this.props.photo.communitybricks.length > 0 ){
            showFilter = false;
        }

        return (
            <div className="product-filter-area d-sm-flex" >
                <div className="large-filter-area d-flex justify-content-between align-items-center" id="filterStart">

                    <div className="filter-dropdown-holder">
                        <div className="pull-left">
                            <button className={this.state.showFilter ? "filter-button open" : "filter-button"} onClick={this.toggleFilter()}>
                                <span className="icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                                Search
                            </button>
                        </div>
                        {clearFilter}
                    </div>

                    <div id="filter-names" className={this.state.showFilter ? "large-filter-content theme-sidebar-widget shadow-lg show-content" : "large-filter-content theme-sidebar-widget shadow-lg"}>
                        <div className="row">
                            <div className="col-lg-3 col-md-5 col-sm-5">
                                <div className="single-block">
                                    <h4 className="sidebar-title">Students</h4>
                                    <ul className="list-item students">
                                        {this.renderProfile()}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-5 col-sm-7">
                                <div className="single-block">
                                    <h4 className="sidebar-title">Year</h4>
                                    <ul className="list-item list-year" style={{ cursor: 'pointer' }}>
                                        {this.renderYearFilter()}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-12">
                                <div className="single-block">
                                    <h4 className="sidebar-title">Event</h4>
                                    <ul className="list-item list-event" style={{ cursor: 'pointer' }}>
                                        {this.renderEventFilter()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-12" style={{display: showFilter == false ? "none" : ""}}>
                            <ul style={{ cursor: 'pointer'}}>
                                <li className={this.state.community == true ? "active" : ""} >
                                    <a className="cmn-link h5" onClick={this.toggleCommunity()} ><img src="/assets/icons/next-arrow.png" width="auto" height="18px"></img> Community</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Filter);